<template>
  <div class="agreement">
    <h1>用户协议</h1>
    <div class="main-box">
      <p>
        <b class="b">重要提示</b>
        <br />{{$company}}（以下简称{{$companyShort}}）在此特别提醒用户认真阅读、充分理解本《用户协议》（下称《协议》）---
        用户应认真阅读、充分理解本《协议》中各条款，包括免除或者限制{{$companyShort}}责任的免责条款及对用户的权利限制条款。请您审慎阅读并选择接受或不接受本《协议》（未成年人应在法定监护人陪同下阅读）。除非您接受本《协议》所有条款，否则您无权注册、登录或使用本协议所涉相关服务。您的注册、登录、使用等行为将视为对本《协议》的接受，并同意接受本《协议》各项条款的约束。
        <br />本《协议》描述{{$companyShort}}与用户之间关于“{{$appName}}”服务相关方面的权利义务。“用户”是指注册、登录、使用、浏览本服务的个人或组织。本《协议》可由{{$companyShort}}随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网站查阅最新版协议条款。在{{$companyShort}}修改《协议》条款后，如果用户不接受修改后的条款，请立即停止使用{{$companyShort}}提供的服务，用户继续使用{{$companyShort}}提供的服务将被视为已接受了修改后的协议。
      </p>
      <p>
        <b class="b">一、使用规则</b> <br />1、<font style="color:red"
          >用户必须年满十八岁，充分了解并同意</font
        >，{{$companyShort}}“{{$appName}}”软件服务（以下称“{{$appName}}”服务）仅为用户提供信息分享、传送及获取的平台，用户必须为自己注册账号下的一切行为负责，包括您所传送的任何内容以及由此产生的任何结果。用户应对“{{$appName}}”服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。{{$companyShort}}无法且不会对因用户行为而导致的任何损失或损害承担责任。
        <br />2、用户在“{{$appName}}”服务中或通过“{{$appName}}”服务所传送的任何内容并不反映{{$companyShort}}的观点或政策，{{$companyShort}}对此不承担任何责任。
        <br />3、用户充分了解并同意，“{{$appName}}”服务是一个基于用户关系网的游戏社交产品，用户须对在“{{$appName}}”服务上的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义传播任何信息；不得恶意使用注册账号导致其他用户误认；否则{{$companyShort}}有权立即停止提供服务，收回“{{$appName}}”服务账号并由用户独自承担由此而产生的一切法律责任。
        <br />4、用户须对在“{{$appName}}”服务上所传送信息的真实性、合法性、无害性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与{{$companyShort}}无关。
        <br />5、{{$companyShort}}保留因业务发展需要，单方面对本服务的全部或部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销“{{$appName}}”服务的权利，用户需承担此风险。
        <br />6、“{{$appName}}”服务提供的服务中可能包括广告，用户同意在使用过程中显示“{{$appName}}”服务和第三方供应商、合作伙伴提供的广告。
        <br />7、用户不得利用{{$companyShort}}或“{{$appName}}”服务制作、上载、复制、发送如下内容：
        <br />(1) 反对宪法所确定的基本原则的； <br />(2)
        危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； <br />(3)
        损害国家荣誉和利益的； <br />(4)
        煽动民族仇恨、民族歧视，破坏民族团结的； <br />(5)
        破坏国家宗教政策，宣扬邪教和封建迷信的； <br />(6)
        散布谣言，扰乱社会秩序，破坏社会稳定的； <br />(7)
        散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； <br />(8)
        侮辱或者诽谤他人，侵害他人合法权益的； <br />(9)
        含有法律、行政法规禁止的其他内容的信息。
        <br />8、{{$companyShort}}公司可依其合理判断，对违反有关法律法规或本协议约定；或侵犯、妨害、威胁任何人权利或安全的内容，或者假冒他人的行为，{{$companyShort}}公司有权依法停止传输任何前述内容，并有权依其自行判断对违反本条款的任何人士采取适当的法律行动，包括但不限于，从“{{$appName}}”服务中删除具有违法性、侵权性、不当性等内容，终止违反者的成员资格，阻止其使用“{{$appName}}”服务全部或部分服务，并且依据法律法规保存有关信息并向有关部门报告等。
        <br />9、用户权利及义务： <br />(1)
        “{{$appName}}”服务账号的所有权归{{$companyShort}}公司所有，用户完成申请注册手续后，获得“{{$appName}}”服务账号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。{{$companyShort}}公司因经营需要，有权回收用户的“{{$appName}}”服务账号。
        <br />(2)
        用户有权更改、删除在“{{$appName}}”服务上的个人资料、注册信息及传送内容等，但需注意，删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户需承担该风险。
        <br />(3)
        用户有责任妥善保管注册账号信息及账号密码的安全，用户需要对注册账号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他成员的账号或密码。在您怀疑他人在使用您的账号或密码时，您同意立即通知{{$companyShort}}公司。
        <br />(4)
        用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，{{$companyShort}}公司有权依据协议终止对违约用户“{{$appName}}”服务账号提供服务。同时，{{$companyShort}}保留在任何时候收回“{{$appName}}”服务账号、用户名的权利。
        <br />(5)
        用户注册“{{$appName}}”服务账号后如果长期不登录该账号，{{$companyShort}}有权回收该账号，以免造成资源浪费，由此带来问题均由用户自行承担。
      </p>

      <p>
        <b class="b"> 二、你的面部识别特征</b><br />
        你选择使用美颜功能某些需要面部信息进行调整，为了综合统计并通过算法做特征分析，用以向你提供更优化的体验与效果，我们可能会使用插件辅助服务的提供，其可能需要收集你的面部识别特征。面部识别特征属于敏感个人信息，拒绝提供该信息仅会使你无法使用上述功能，但不影响“{{$appName}}”其他功能与服务的正常使用:
        当你使用美颜瘦脸、大眼等功能时，为了优化体验与展示效果，我们可能会使用终端设备的TrueDepth
        API获取你的面部特征信息。这些信息仅用于渲染效果，我们不会将这些信息回传服务器,也不会存储这些信息，更不会将其用于除此以外的任何其他目的或提供给第三方;
        请你了解，我们收集、使用上述信息时进行了去标识化处理/匿名化处理，数据分析仅对应特定的、无法直接关联用户身份的编码。
      </p>

      <p>
        <b class="b">三、服务内容</b>
        <br />1、“{{$appName}}”服务的具体内容由{{$companyShort}}根据实际情况提供，包括但不限于授权用户通过其账号进行即时通讯、添加好友、关注他人、发布个人动态、做任务。{{$companyShort}}可以对其提供的服务予以变更，且{{$companyShort}}提供的服务内容可能随时变更；用户将会收到{{$companyShort}}关于服务变更的通知。
        <br />2、{{$companyShort}}提供的服务包含免费服务与收费服务。用户可以通过付费方式购买收费服务，具体方式为：用户通过网上银行、支付宝、手机话费、充值卡、微信支付、苹果支付等支付一定数额的人民币购买“{{$appName}}”平台的虚拟货币——钻石，然后根据{{$companyShort}}公布的资费标准以钻石购买用户欲使用的收费服务，从而获得收费服务使用权限。对于收费服务，{{$companyShort}}会在用户使用之前给予用户明确的提示，只有用户根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，用户才能使用该等收费服务。支付行为的完成以银行或第三方支付平台生成“支付已完成”的确认通知为准。
      </p>

      <p>
        <b class="b">四、虚拟货币</b>
        <br />1、{{$companyShort}}将在“{{$appName}}”平台发行虚拟货币——钻石。钻石可用于购买“{{$appName}}”平台的收费服务，包括但不限于道具、虚拟礼物，除此外，不得用于其他任何用途。该等收费服务的价格均以钻石为单位，具体价格信息将由{{$companyShort}}自行决定并在相关服务页面上显示。
        <br />2、钻石和人民币的兑换比例是10:1，兑换比例将由{{$companyShort}}根据运营情况随时变更，并将在用户购买钻石的相关服务页面上显示。
        <br />3、用户默认已开通钻石账户，可进行钻石购买和消费。用户可在设置页面查询到钻石余额、购买记录和消费记录。钻石相关信息将不作为公开信息。
        <br />4、用户可以通过网上银行、支付宝或其他“{{$appName}}”平台提供的充值途径为钻石账户进行充值。用户使用钻石购买相关收费服务后，可将相关收费服务赠与其他用户。
        <br />5、用户确认，钻石一经充值成功，除法律法规明确规定外，在任何情况下不能兑换为法定货币，不能转让他人。除法律法规明确规定外，钻石账户充值完成后，{{$companyShort}}不予退款。
        <br />6、用户确认，钻石只能用于购买“{{$appName}}”平台上的各类收费服务，任何情况下不得与{{$companyShort}}以外的第三方进行钻石交易，亦不得在除“{{$appName}}”平台以外的第三方平台（如淘宝）上进行交易；如违反前述约定，造成用户或第三方任何损失，{{$companyShort}}不负任何责任，且如{{$companyShort}}有理由怀疑用户的钻石帐户或使用情况有作弊或异常状况，{{$companyShort}}将拒绝该用户使用钻石进行支付，直至按本协议约定采取相关封禁措施。
        <br />7、用户须明白，使用“{{$appName}}”服务因涉及Internet服务，可能会受到各个环节不稳定因素的影响。因此，“{{$appName}}”服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。在此情况下，用户不得利用系统故障进行任何违规操作，例如违规获取钻石虚拟货币。如违反前述约定，{{$companyShort}}有权依据协议对违约用户的“{{$appName}}”服务账号进行处理，包括但不限于对违规账号的虚拟货币以及虚拟货币产生的交易数值进行清除等。同时，{{$companyShort}}保留在任何时候收回“{{$appName}}”服务账号、用户名的权利。
        <br />8、用户确认，除法律法规明确规定或本协议另有约定外，用户已购买的任何收费服务不能以任何理由退购（即退换成钻石或法定货币）或调换成其他服务。
      </p>
      <p>
        <b class="b">五、用户隐私</b><br />
        我们提供的服务可能需要您在您的设备中开启您的位置信息
        （地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）、通讯录的访问权限，以实现这些权限所涉及信息的收集和使用。
        我们会在您使用相关服务时弹窗提示您是否要开启相应权限。您可在您的设备设置或客户端“更多-设置-隐私—系统权限管理”中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。
        请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。
        但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
      </p>
      <p>
        在您使用“{{$appName}}”的同时，可能会获取您手机的以下权限:<br />
        1.读取相册照片权限:用于上传头像、上传图片
        到我的相册、保存图片到相册、发送图片;<br />
        2.相机权限:用于上传头像、上传图片 到我的相册、发送图片;<br />
        3.麦克风权限:用于频道通话、发送语音、录制声音;<br />
        4.短信权限:用于手机号注册、登录、绑定时读取验证码;<br />
        5.位置获取权限:基于网络的大概位置，用于用户地理距离显示;<br />
        对于安卓系统的用户，在使用{{$appName}}时，{{$appName}}公司可能会获取您终端设备一下权限，以维护提升产品，提供更好的服务:<br />
        1.读取手机状态:用于检测网络状态;<br />
        2.写入磁盘:用于缓存文档、日志记录。<br />
      </p>
      <p>
        <b class="b">六、隐私保护</b>
        <br />用户同意个人隐私信息是指那些能够对用户进行个人辨识或涉及个人通信的信息，包括下列信息：用户真实姓名，身份证号，手机号码，IP地址。而非个人隐私信息是指用户对本服务的操作状态以及使用习惯等一些明确且客观反映在{{$companyShort}}服务器端的基本记录信息和其他一切个人隐私信息范围外的普通信息；以及用户同意公开的上述隐私信息；
        <br />尊重用户个人隐私信息的私有性是{{$companyShort}}的一贯制度，{{$companyShort}}将会采取合理的措施保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或用户同意等原因外，{{$companyShort}}未经用户同意不向除合作单位以外的第三方公开、
        透露用户个人隐私信息。
        但是，用户在注册时选择同意，或用户与{{$companyShort}}及合作单位之间就用户个人隐私信息公开或使用另有约定的除外，同时用户应自行承担因此可能产生的任何风险，{{$companyShort}}对此不予负责。为了运营和改善{{$companyShort}}的技术和服务，{{$companyShort}}将可能会自行收集使用或向第三方提供用户的非个人隐私信息，同时在使用过程中可能需要获取手机一些权限，例如GPS地理位置权限让用户找到身边的玩家进行互动、麦克风权限让用户进行语音对话、摄像头与相册权限让用户把摄影的图片保存到手机相册中，这将有助于{{$companyShort}}向用户提供更好的用户体验和提高{{$companyShort}}的服务质量。
        <br />用户同意，在使用“{{$appName}}”服务服务时也同样受{{$companyShort}}隐私政策的约束。当您接受本协议条款时，您同样认可并接受{{$companyShort}}公司隐私政策的条款。
      </p>
      <p>
        <b class="b">七、“{{$appName}}”服务商标信息</b>
        <br />“{{$appName}}”服务服务中所涉及的图形、文字或其组成，以及其他{{$companyShort}}标志及产品、服务名称，均为{{$companyShort}}公司之商标（以下简称“{{$companyShort}}标识”）。未经{{$companyShort}}事先书面同意，用户不得将{{$companyShort}}标识以任何方式展示或使用或作其他处理，也不得向他人表明您有权展示、使用、或其他有权处理{{$companyShort}}标识的行为。
      </p>
      <p>
        <b class="b">八、法律责任及免责</b>
        <br />1、用户违反本《协议》或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿{{$companyShort}}与合作公司、关联公司，并使之免受损害。
        <br />2、用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，{{$companyShort}}及合作单位不承担责任。
        <br />3、因技术故障等不可抗事件影响到服务的正常运行的，{{$companyShort}}及合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，{{$companyShort}}及合作单位不承担责任。
        <br />4、“{{$appName}}”服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响“{{$appName}}”服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
        <br />5、用户须明白，使用“{{$appName}}”服务因涉及Internet服务，可能会受到各个环节不稳定因素的影响。因此，“{{$appName}}”服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。用户须承担以上风险，{{$companyShort}}公司不作担保。对因此导致用户不能发送和接受阅读信息、或接发错信息，{{$companyShort}}公司不承担任何责任。
        <br />6、用户须明白，在使用“{{$appName}}”服务过程中存在有来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）的匿名或冒名的信息的风险，用户须承担以上风险，{{$companyShort}}公司和合作公司对“{{$appName}}”服务不作任何类型的担保，不论是明确的或隐含的，包括所有有关信息真实性、适商性、适于某一特定用途、所有权和非侵权性的默示担保和条件，对因此导致任何因用户不正当或非法使用服务产生的直接、间接、偶然、特殊及后续的损害，不承担任何责任。
        <br />7、{{$companyShort}}公司定义的信息内容包括：文字、软件、声音、相片、录像、图表；在广告中全部内容；{{$companyShort}}公司为用户提供的商业信息，所有这些内容受版权、商标权、和其它知识产权和所有权法律的保护。所以，用户只能在{{$companyShort}}公司和广告商授权下才能使用这些内容，而不能擅自复制、修改、编纂这些内容、或创造与内容有关的衍生产品。
        <br />8、在任何情况下，{{$companyShort}}公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用“{{$appName}}”服务服务而遭受的利润损失，承担责任（即使“{{$appName}}”服务已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，{{$companyShort}}公司对您承担的全部责任，无论因何原因或何种行为方式，始终以您在成员期内因使用“{{$appName}}”服务服务而支付给{{$companyShort}}公司的费用(如有)为限
        。
      </p>
      <p>
        <b class="b">九、“{{$appName}}”服务社区管理规则</b>
        <br />“{{$appName}}”服务是和现实相关的社交产品，希望用户相互尊重，遵循和现实社会一样的社交礼仪。
        <br />为避免遭到用户举报而被封禁设备，请您遵守以下原则：
        <br />1、请勿发送涉嫌性骚扰的文字、图片及语音信息；
        <br />2、请勿使用含色情、淫秽意味或其他令人不适的头像或资料；
        <br />3、请勿在交谈中使用辱骂、恐吓、威胁等言论；
        <br />4、请勿发布各类垃圾广告、恶意信息、诱骗信息；
        <br />5、请勿盗用他人头像或资料，请勿伪装他人身份；
        <br />6、请勿发布不当政治言论或者任何违反国家法规政策的言论。
        <br />因违反用户协议被封禁的用户，可以向“{{$appName}}”服务提起申述，炼爱将根据用户实际情况决定是否解除禁止。
        <br />如用户违反社区管理规则，{{$companyShort}}公司有权依据协议终止对违约用户“{{$appName}}”服务账号提供服务。同时，{{$companyShort}}保留在任何时候收回“{{$appName}}”服务账号的权力。
      </p>

      <p>
        <b class="b">十、其他条款</b>
        <br />1、{{$companyShort}}公司郑重提醒用户注意本《协议》中免除{{$companyShort}}公司责任和加重用户义务的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本《协议》。以上各项条款内容的最终解释权及修改权归{{$companyShort}}公司所有。
        <br />2、本《协议》所定的任何条款的部分或全部无效者，不影响其它条款的效力。
        <br />3、本《协议》的版权由{{$companyShort}}所有，{{$companyShort}}保留一切解释和修改权利。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.agreement {
  width: 59%;
  margin: 30px auto 0 auto;
  font-size: 16px;
  color: #333;
  text-align: left;
  h1 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  .main-box {
    height: 500px;
    overflow-y: scroll;
    p {
      margin-bottom: 30px;
      line-height: 28px;
      .b {
        margin-bottom: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agreement.vue